// This file is auto-generated by @hey-api/openapi-ts

export const PaginatedResultDTOSchema = {
    type: 'object',
    properties: {
        total: {
            type: 'number'
        },
        offset: {
            type: 'number'
        }
    },
    required: ['total', 'offset']
} as const;

export const UserDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        authId: {
            type: 'string'
        },
        sub: {
            type: 'string'
        },
        displayName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        activated: {
            type: 'boolean'
        },
        admin: {
            type: 'boolean'
        },
        organisationId: {
            type: 'string'
        },
        jobsiteIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        preferredJobsiteId: {
            type: 'string'
        }
    },
    required: ['id', 'displayName', 'email', 'activated', 'admin', 'organisationId', 'jobsiteIds']
} as const;

export const StringFilterDTOSchema = {
    type: 'object',
    properties: {
        in: {
            description: 'in filter operator for strings',
            example: '{"in":["foo"]}',
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
} as const;

export const UserFilterDTOSchema = {
    type: 'object',
    properties: {
        _id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        organisation: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        displayName: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        email: {
            '$ref': '#/components/schemas/StringFilterDTO'
        }
    }
} as const;

export const UserQueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const UserCreateDTOSchema = {
    type: 'object',
    properties: {
        email: {
            type: 'string'
        },
        admin: {
            type: 'boolean'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        organisationId: {
            type: 'string'
        }
    },
    required: ['email', 'admin', 'firstName', 'lastName', 'organisationId']
} as const;

export const OrganisationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        zitadelOrgId: {
            type: 'string'
        },
        userIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        jobsiteIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['id', 'name', 'userIds', 'jobsiteIds']
} as const;

export const JobsiteDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        capturer_id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        organisationId: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['truck', 'train', 'heap', 'belt']
        },
        features: {
            type: 'object'
        }
    },
    required: ['id', 'capturer_id', 'name', 'organisationId', 'type']
} as const;

export const UserPopulatedDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        authId: {
            type: 'string'
        },
        sub: {
            type: 'string'
        },
        displayName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        activated: {
            type: 'boolean'
        },
        admin: {
            type: 'boolean'
        },
        organisation: {
            '$ref': '#/components/schemas/OrganisationDTO'
        },
        jobsites: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JobsiteDTO'
            }
        },
        preferredJobsite: {
            '$ref': '#/components/schemas/JobsiteDTO'
        }
    },
    required: ['id', 'displayName', 'email', 'activated', 'admin', 'organisation', 'jobsites']
} as const;

export const UserUpdateDTOSchema = {
    type: 'object',
    properties: {
        displayName: {
            type: 'string'
        },
        admin: {
            type: 'boolean'
        },
        jobsiteIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        preferredJobsiteId: {
            type: 'string'
        }
    }
} as const;

export const DeliveryDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            description: 'The internal database id of the delivery'
        },
        delivery_id: {
            type: 'string',
            description: 'The delivery id as provided by the customer'
        },
        customer_id: {
            type: 'string'
        },
        date: {
            format: 'date-time',
            type: 'string'
        },
        material: {
            type: 'string'
        },
        material_id: {
            type: 'string'
        },
        netto_weight: {
            type: 'number'
        },
        numberplate: {
            type: 'string'
        },
        supplier: {
            type: 'string'
        },
        construction_site: {
            type: 'string'
        },
        construction_site_id: {
            type: 'string'
        },
        avv: {
            type: 'string'
        },
        detail: {
            type: 'string'
        },
        data: {
            type: 'object'
        },
        jobsiteId: {
            type: 'string'
        },
        pictureIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['id', 'delivery_id', 'customer_id', 'date', 'material', 'material_id', 'netto_weight', 'numberplate', 'supplier', 'construction_site', 'construction_site_id', 'avv', 'detail', 'data', 'jobsiteId', 'pictureIds']
} as const;

export const DateRangeDTOSchema = {
    type: 'object',
    properties: {
        gte: {
            type: 'string',
            description: 'greater than or equal filter operator',
            example: {
                gte: '2024-09-23T00:00:00Z'
            }
        },
        lt: {
            type: 'string',
            description: 'less than filter operator',
            example: {
                lt: '2024-09-23T14:03:00Z'
            }
        }
    }
} as const;

export const DateFilterDTOSchema = {
    type: 'object',
    properties: {
        range: {
            description: 'range filter operator for dates',
            example: '{"gte":"2024-09-23T00:00:00Z","lt":"2024-09-23T14:03:00Z"}',
            allOf: [
                {
                    '$ref': '#/components/schemas/DateRangeDTO'
                }
            ]
        }
    }
} as const;

export const NumberRangeDTOSchema = {
    type: 'object',
    properties: {
        gte: {
            type: 'number',
            description: 'greater than or equal filter operator',
            example: '{"gte":0}'
        },
        lte: {
            type: 'number',
            description: 'less than or equal filter operator',
            example: '{"lte":10}'
        }
    }
} as const;

export const FloatFilterDTOSchema = {
    type: 'object',
    properties: {
        range: {
            description: 'range filter operator for floats',
            example: '{"gte":0,"lte":10}',
            allOf: [
                {
                    '$ref': '#/components/schemas/NumberRangeDTO'
                }
            ]
        }
    }
} as const;

export const BooleanFilterDTOSchema = {
    type: 'object',
    properties: {
        eq: {
            type: 'boolean',
            description: 'eq filter operator',
            example: '{"eq":true}'
        }
    }
} as const;

export const DeliveryFilterDTOSchema = {
    type: 'object',
    properties: {
        _id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        avv: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        construction_site: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        construction_site_id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        customer_id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        date: {
            '$ref': '#/components/schemas/DateFilterDTO'
        },
        delivery_id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        material: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        material_id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        netto_weight: {
            '$ref': '#/components/schemas/FloatFilterDTO'
        },
        numberplate: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        supplier: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        has_truck_scan_img: {
            '$ref': '#/components/schemas/BooleanFilterDTO'
        }
    }
} as const;

export const DeliveryQueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const FilterStringOptionDTOSchema = {
    type: 'object',
    properties: {
        value: {
            type: 'string',
            description: 'value of the filter option'
        },
        count: {
            type: 'number',
            description: 'number of items matching the filter option'
        }
    },
    required: ['value', 'count']
} as const;

export const FilterDateRangeOptionDTOSchema = {
    type: 'object',
    properties: {
        min: {
            format: 'date-time',
            type: 'string'
        },
        max: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['min', 'max']
} as const;

export const FilterNumberRangeOptionDTOSchema = {
    type: 'object',
    properties: {
        min: {
            type: 'number'
        },
        max: {
            type: 'number'
        }
    },
    required: ['min', 'max']
} as const;

export const FilterBooleanOptionDTOSchema = {
    type: 'object',
    properties: {
        trueCount: {
            type: 'number',
            description: 'number of items matching if the value is true'
        },
        falseCount: {
            type: 'number',
            description: 'number of items matching if the value is false'
        }
    },
    required: ['trueCount', 'falseCount']
} as const;

export const DeliveryFilterOptionsDTOSchema = {
    type: 'object',
    properties: {
        avv: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        construction_site: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        construction_site_id: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        customer_id: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        date: {
            '$ref': '#/components/schemas/FilterDateRangeOptionDTO'
        },
        delivery_id: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        material: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        material_id: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        netto_weight: {
            '$ref': '#/components/schemas/FilterNumberRangeOptionDTO'
        },
        numberplate: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        supplier: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        has_truck_scan_img: {
            '$ref': '#/components/schemas/FilterBooleanOptionDTO'
        }
    }
} as const;

export const ProblemTypesDTOSchema = {
    type: 'object',
    properties: {
        image: {
            type: 'boolean'
        },
        prediction: {
            type: 'boolean'
        },
        assignment: {
            type: 'boolean'
        },
        other: {
            type: 'boolean'
        },
        comment: {
            type: 'string'
        }
    },
    required: ['image', 'prediction', 'assignment', 'other']
} as const;

export const ProblemReportDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        contentId: {
            type: 'object'
        },
        userId: {
            type: 'string'
        },
        problem: {
            '$ref': '#/components/schemas/ProblemTypesDTO'
        },
        log: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['id', 'contentId', 'userId', 'log']
} as const;

export const UpdateProblemReportDTOSchema = {
    type: 'object',
    properties: {
        problem: {
            '$ref': '#/components/schemas/ProblemTypesDTO'
        }
    },
    required: ['problem']
} as const;

export const JobsiteFilterDTOSchema = {
    type: 'object',
    properties: {
        _id: {
            '$ref': '#/components/schemas/StringFilterDTO'
        }
    }
} as const;

export const JobsiteQueryDTOSchema = {
    type: 'object',
    properties: {
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const JobsiteUpdateDTOSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        }
    },
    required: ['name']
} as const;

export const ActivityDTOSchema = {
    type: 'object',
    properties: {
        capture_start_at: {
            format: 'date-time',
            type: 'string'
        },
        image_id: {
            type: 'string'
        },
        motion_reversed: {
            type: 'boolean'
        }
    },
    required: ['capture_start_at', 'image_id', 'motion_reversed']
} as const;

export const LicensePlateDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        captured_at: {
            type: 'string'
        },
        capturer_id: {
            type: 'string'
        },
        ocr_text: {
            type: 'string'
        }
    },
    required: ['id', 'captured_at', 'capturer_id', 'ocr_text']
} as const;

export const MaterialClassificationItemDTOSchema = {
    type: 'object',
    properties: {
        class_name: {
            type: 'string'
        },
        avv: {
            type: 'string'
        },
        probability: {
            type: 'number'
        }
    },
    required: ['class_name', 'avv', 'probability']
} as const;

export const MaterialClassificationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        output: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MaterialClassificationItemDTO'
            }
        }
    },
    required: ['id', 'output']
} as const;

export const EdgeSizesPredictionDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        output: {
            type: 'array',
            description: 'Dimensions of detected objects in meters as [width, height] or [width, height, [x1, y1, x2, y2]], where bbox coordinates are relative values between 0 and 1.',
            items: {
                oneOf: [
                    {
                        type: 'array',
                        minItems: 2,
                        maxItems: 2,
                        items: {
                            type: 'number'
                        }
                    },
                    {
                        type: 'array',
                        minItems: 3,
                        maxItems: 3,
                        items: {
                            oneOf: [
                                {
                                    type: 'number'
                                },
                                {
                                    type: 'array',
                                    minItems: 4,
                                    maxItems: 4,
                                    items: {
                                        type: 'number'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    },
    required: ['id', 'output']
} as const;

export const SoilClassificationOutputDTOSchema = {
    type: 'object',
    properties: {
        color: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            }
        },
        grainsize: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            }
        },
        gravel: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            },
            description: 'Proportion of material that is gravel'
        },
        mixed_waste: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            },
            description: 'Proportion of material that is mixed waste'
        },
        wet: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            }
        },
        biomaterials: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            },
            description: 'Biomaterials presence'
        },
        plant_materials: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            },
            description: 'Presence of plant materials'
        },
        brightness: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            }
        },
        sticky: {
            type: 'object',
            additionalProperties: {
                type: 'number'
            }
        }
    },
    required: ['color', 'grainsize', 'gravel', 'mixed_waste', 'wet', 'biomaterials', 'plant_materials', 'brightness', 'sticky']
} as const;

export const SoilClassificationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        output: {
            description: 'Soil classification prediction results with probabilities for each class value.',
            allOf: [
                {
                    '$ref': '#/components/schemas/SoilClassificationOutputDTO'
                }
            ]
        }
    },
    required: ['id', 'output']
} as const;

export const VolumeEstimationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        license_plate: {
            type: 'string'
        },
        empty_volume: {
            type: 'number',
            description: 'Volume in cubic meters (m³)'
        },
        batch_volume: {
            type: 'number',
            description: 'Volume in cubic meters (m³)'
        }
    },
    required: ['id', 'license_plate', 'empty_volume', 'batch_volume']
} as const;

export const SelfServiceSessionDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        jobsite_id: {
            type: 'string'
        },
        capturer_id: {
            type: 'string'
        },
        session_start_at: {
            format: 'date-time',
            type: 'string'
        },
        session_end_at: {
            format: 'date-time',
            type: 'string'
        },
        session_extended: {
            type: 'number'
        },
        events: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        status: {
            type: 'string',
            enum: ['active', 'suspended', 'completed', 'cancelled', 'failed', 'expired'],
            description: 'Stored session status, "expired" when an active session has passed session_end_at'
        },
        accessMode: {
            type: 'string',
            enum: ['terminal', 'user-device']
        },
        suspended_until: {
            format: 'date-time',
            type: 'string',
            nullable: true
        }
    },
    required: ['id', 'jobsite_id', 'capturer_id', 'session_start_at', 'session_end_at', 'session_extended', 'events', 'status', 'accessMode', 'suspended_until']
} as const;

export const ErrorMsgSchema = {
    type: 'object',
    properties: {
        message: {
            type: 'string'
        }
    },
    required: ['message']
} as const;

export const TextFieldSchema = {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        value: {
            type: 'string'
        },
        editable: {
            type: 'boolean'
        },
        error: {
            '$ref': '#/components/schemas/ErrorMsg'
        },
        type: {
            type: 'string',
            enum: ['text']
        }
    },
    required: ['key', 'label', 'required', 'value', 'editable', 'type']
} as const;

export const SelectFieldSchema = {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        value: {
            type: 'string'
        },
        editable: {
            type: 'boolean'
        },
        error: {
            '$ref': '#/components/schemas/ErrorMsg'
        },
        type: {
            type: 'string',
            enum: ['select']
        },
        options: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['key', 'label', 'required', 'value', 'editable', 'type', 'options']
} as const;

export const FormFieldsSchema = {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        fields: {
            type: 'array',
            items: {
                oneOf: [
                    {
                        '$ref': '#/components/schemas/TextField'
                    },
                    {
                        '$ref': '#/components/schemas/SelectField'
                    }
                ],
                discriminator: {
                    propertyName: 'type',
                    mapping: {
                        text: '#/components/schemas/TextField',
                        select: '#/components/schemas/SelectField'
                    }
                }
            }
        }
    },
    required: ['fields']
} as const;

export const FormInstructionSchema = {
    type: 'object',
    properties: {
        instructionId: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending']
        },
        component: {
            type: 'string',
            enum: ['form']
        },
        parameters: {
            '$ref': '#/components/schemas/FormFields'
        }
    },
    required: ['instructionId', 'component', 'parameters']
} as const;

export const TaskParametersSchema = {
    type: 'object',
    properties: {
        description: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        imageUrl: {
            type: 'string'
        },
        error: {
            '$ref': '#/components/schemas/ErrorMsg'
        }
    },
    required: ['description', 'key']
} as const;

export const TaskInstructionSchema = {
    type: 'object',
    properties: {
        instructionId: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending']
        },
        component: {
            type: 'string',
            enum: ['task']
        },
        parameters: {
            '$ref': '#/components/schemas/TaskParameters'
        }
    },
    required: ['instructionId', 'component', 'parameters']
} as const;

export const PdfParametersSchema = {
    type: 'object',
    properties: {
        description: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        pdfUrl: {
            type: 'string'
        },
        pdfBase64: {
            type: 'string'
        }
    },
    required: ['description', 'key']
} as const;

export const PdfInstructionSchema = {
    type: 'object',
    properties: {
        instructionId: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending']
        },
        component: {
            type: 'string',
            enum: ['pdf']
        },
        parameters: {
            '$ref': '#/components/schemas/PdfParameters'
        }
    },
    required: ['instructionId', 'component', 'parameters']
} as const;

export const OcInsightsImageParamsSchema = {
    type: 'object',
    properties: {
        captureStartAt: {
            type: 'string',
            nullable: true
        },
        switchedImage: {
            type: 'boolean'
        }
    }
} as const;

export const OcInsightsLicensePlateParamsSchema = {
    type: 'object',
    properties: {
        capturedAt: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const OcInsightsMaterialParamsSchema = {
    type: 'object',
    properties: {
        status: {
            type: 'string',
            enum: ['approved', 'overridden'],
            nullable: true
        },
        selectedMaterial: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const OcInsightsTimeoutParamsSchema = {
    type: 'object',
    properties: {
        imageTimeoutMs: {
            type: 'number'
        },
        materialPredictionTimeoutMs: {
            type: 'number'
        }
    }
} as const;

export const OcInsightsParametersSchema = {
    type: 'object',
    properties: {
        image: {
            '$ref': '#/components/schemas/OcInsightsImageParams'
        },
        licensePlate: {
            '$ref': '#/components/schemas/OcInsightsLicensePlateParams'
        },
        material: {
            '$ref': '#/components/schemas/OcInsightsMaterialParams'
        },
        timeout: {
            '$ref': '#/components/schemas/OcInsightsTimeoutParams'
        }
    }
} as const;

export const OcInsightsInstructionSchema = {
    type: 'object',
    properties: {
        instructionId: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending']
        },
        component: {
            type: 'string',
            enum: ['oc-insights']
        },
        parameters: {
            '$ref': '#/components/schemas/OcInsightsParameters'
        }
    },
    required: ['instructionId', 'component']
} as const;

export const SuccessInstructionSchema = {
    type: 'object',
    properties: {
        instructionId: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending']
        },
        component: {
            type: 'string',
            enum: ['success']
        },
        parameters: {
            type: 'object',
            default: {}
        }
    },
    required: ['instructionId', 'component']
} as const;

export const SessionImageCandidateDTOSchema = {
    type: 'object',
    properties: {
        imageId: {
            type: 'string',
            description: 'Image ID of truck_scan_image'
        },
        imagePresignedUrl: {
            type: 'string',
            description: 'Presigned url to truck_scan_image stored in Minio'
        },
        captureStartAt: {
            type: 'string',
            description: 'Capture start timestamp for the truck_scan_image'
        },
        licensePlate: {
            type: 'string',
            description: 'Best matching license plate for this image, if available',
            nullable: true
        },
        licensePlateCapturedAt: {
            type: 'string',
            description: 'Capture timestamp of the best matching license plate frame, if available',
            nullable: true
        }
    },
    required: ['imageId', 'imagePresignedUrl', 'captureStartAt']
} as const;

export const SessionImageDTOSchema = {
    type: 'object',
    properties: {
        imageId: {
            type: 'string',
            description: 'Image ID of truck_scan_image'
        },
        imagePresignedUrl: {
            type: 'string',
            description: 'Presigned url to truck_scan_image stored in Minio'
        }
    },
    required: ['imageId', 'imagePresignedUrl']
} as const;

export const ImageFeedbackDTOSchema = {
    type: 'object',
    properties: {
        message: {
            type: 'string'
        }
    },
    required: ['message']
} as const;

export const SessionEventDTOSchema = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: ['extend', 'cancel', 'completed', 'api-error'],
            description: 'Type of event to record for the session'
        }
    },
    required: ['type']
} as const;

export const TriggerHeapCaptureResponseDTOSchema = {
    type: 'object',
    properties: {
        trigger_id: {
            type: 'string'
        }
    },
    required: ['trigger_id']
} as const;

export const GetPresignedDownloadUrlDTOSchema = {
    type: 'object',
    properties: {
        bucket: {
            type: 'string'
        },
        object: {
            type: 'string'
        }
    },
    required: ['bucket', 'object']
} as const;

export const PresignedDownloadUrlResponseDTOSchema = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        }
    },
    required: ['url']
} as const;

export const TranslatedFieldSchema = {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        }
    },
    required: ['key', 'value']
} as const;

export const ComplaintReportHeapDetectionsSchema = {
    type: 'object',
    properties: {
        bbox: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'number'
                }
            }
        },
        displayClasses: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'string'
                }
            }
        },
        colors: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['bbox', 'displayClasses', 'colors']
} as const;

export const TranslatedComplaintReportHeapDetectionsSchema = {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        value: {
            '$ref': '#/components/schemas/ComplaintReportHeapDetections'
        }
    },
    required: ['key', 'value']
} as const;

export const HeapComplaintReportSchema = {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        recordedAt: {
            type: 'string'
        },
        datetime: {
            '$ref': '#/components/schemas/TranslatedField'
        },
        licensePlate: {
            '$ref': '#/components/schemas/TranslatedField'
        },
        text: {
            '$ref': '#/components/schemas/TranslatedField'
        },
        detections: {
            '$ref': '#/components/schemas/TranslatedComplaintReportHeapDetections'
        }
    },
    required: ['title', 'recordedAt', 'datetime', 'licensePlate', 'text', 'detections']
} as const;

export const MaterialConditionDTOSchema = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: ['material']
        },
        className: {
            type: 'string',
            enum: ['bags', 'bitumen', 'brick_tile', 'concrete', 'covered', 'empty', 'gravel', 'gypsum', 'metal', 'mixed_construction_waste', 'mixed_mineralic_waste', 'soil', 'track_ballast', 'wood']
        },
        probability: {
            type: 'number'
        }
    },
    required: ['type', 'className', 'probability']
} as const;

export const SoilConditionDTOSchema = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: ['soil']
        },
        category: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        minConfidence: {
            type: 'number'
        }
    },
    required: ['type', 'category', 'value', 'minConfidence']
} as const;

export const EdgeConditionThresholdTypeSchema = {
    type: 'string',
    enum: ['min', 'max']
} as const;

export const EdgeConditionDTOSchema = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: ['edge']
        },
        operator: {
            type: 'string',
            enum: ['<', '<=', '>=', '>']
        },
        value: {
            type: 'number'
        },
        thresholdCount: {
            type: 'number'
        },
        thresholdMode: {
            '$ref': '#/components/schemas/EdgeConditionThresholdType'
        }
    },
    required: ['type', 'operator', 'value', 'thresholdCount', 'thresholdMode']
} as const;

export const ConditionSetDTOSchema = {
    type: 'object',
    properties: {
        conditions: {
            type: 'array',
            items: {
                oneOf: [
                    {
                        '$ref': '#/components/schemas/MaterialConditionDTO'
                    },
                    {
                        '$ref': '#/components/schemas/SoilConditionDTO'
                    },
                    {
                        '$ref': '#/components/schemas/EdgeConditionDTO'
                    }
                ],
                discriminator: {
                    propertyName: 'type',
                    mapping: {
                        material: '#/components/schemas/MaterialConditionDTO',
                        soil: '#/components/schemas/SoilConditionDTO',
                        edge: '#/components/schemas/EdgeConditionDTO'
                    }
                }
            }
        }
    },
    required: ['conditions']
} as const;

export const BillableMaterialDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        article_number: {
            type: 'string'
        },
        condition_set: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ConditionSetDTO'
            }
        },
        jobsite_ids: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        organisation_id: {
            type: 'string'
        }
    },
    required: ['id', 'name', 'condition_set', 'jobsite_ids', 'organisation_id']
} as const;

export const CreateBillableMaterialDTOSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        article_number: {
            type: 'string'
        },
        condition_set: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ConditionSetDTO'
            }
        },
        jobsite_ids: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['name', 'condition_set', 'jobsite_ids']
} as const;

export const UpdateBillableMaterialDTOSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        article_number: {
            type: 'string'
        },
        condition_set: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ConditionSetDTO'
            }
        },
        jobsite_ids: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
} as const;

export const TruckRecordingDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        motion_start_at: {
            format: 'date-time',
            type: 'string'
        },
        jobsite_id: {
            type: 'string'
        },
        image_id: {
            type: 'string'
        },
        motion_reversed: {
            type: 'boolean'
        },
        capture_start_at: {
            format: 'date-time',
            type: 'string'
        },
        license_plate: {
            type: 'string'
        },
        delivery_id: {
            type: 'string'
        }
    },
    required: ['id', 'motion_start_at', 'jobsite_id', 'image_id', 'motion_reversed', 'capture_start_at']
} as const;

export const TruckRecordingFilterDTOSchema = {
    type: 'object',
    properties: {
        motion_start_at: {
            '$ref': '#/components/schemas/DateFilterDTO'
        }
    }
} as const;

export const TruckRecordingQueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const MipIdReferenceDtoSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        }
    },
    required: ['id']
} as const;

export const MipProcessingStatusDtoSchema = {
    type: 'object',
    properties: {
        progress: {
            type: 'number'
        },
        finishedAt: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['progress']
} as const;

export const MipEvaluatorInstanceVersionDtoSchema = {
    type: 'object',
    properties: {
        evaluatorInstance: {
            '$ref': '#/components/schemas/MipIdReferenceDto'
        },
        version: {
            type: 'number'
        }
    },
    required: ['evaluatorInstance', 'version']
} as const;

export const MipReporterVersionDtoSchema = {
    type: 'object',
    properties: {
        reporterInstance: {
            '$ref': '#/components/schemas/MipIdReferenceDto'
        },
        version: {
            type: 'number'
        }
    },
    required: ['reporterInstance', 'version']
} as const;

export const MipEvaluationReportReferenceDtoSchema = {
    type: 'object',
    properties: {
        reporterInstance: {
            '$ref': '#/components/schemas/MipIdReferenceDto'
        },
        reporterInstanceVersion: {
            type: 'number'
        },
        report: {
            '$ref': '#/components/schemas/MipIdReferenceDto'
        }
    },
    required: ['reporterInstance', 'reporterInstanceVersion', 'report']
} as const;

export const MipEvaluationDtoSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        deletedAt: {
            type: 'string',
            format: 'date-time'
        },
        evaluatorInstanceVersion: {
            '$ref': '#/components/schemas/MipEvaluatorInstanceVersionDto'
        },
        report: {
            '$ref': '#/components/schemas/MipEvaluationReportReferenceDto'
        },
        data: {
            type: 'object'
        },
        processingStatus: {
            '$ref': '#/components/schemas/MipProcessingStatusDto'
        },
        version: {
            type: 'number'
        }
    },
    required: ['id', 'evaluatorInstanceVersion', 'report', 'data', 'processingStatus', 'version']
} as const;

export const MipReportDtoSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        deletedAt: {
            type: 'string',
            format: 'date-time'
        },
        reporterVersion: {
            '$ref': '#/components/schemas/MipReporterVersionDto'
        },
        observedAt: {
            type: 'string',
            format: 'date-time'
        },
        data: {
            type: 'object'
        },
        processingStatus: {
            '$ref': '#/components/schemas/MipProcessingStatusDto'
        },
        version: {
            type: 'number'
        }
    },
    required: ['id', 'reporterVersion', 'observedAt', 'data', 'processingStatus', 'version']
} as const;

export const TruckRecordingMipEvaluationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        deletedAt: {
            type: 'string',
            format: 'date-time'
        },
        evaluatorInstanceVersion: {
            '$ref': '#/components/schemas/MipEvaluatorInstanceVersionDto'
        },
        report: {
            '$ref': '#/components/schemas/MipEvaluationReportReferenceDto'
        },
        processingStatus: {
            '$ref': '#/components/schemas/MipProcessingStatusDto'
        },
        version: {
            type: 'number'
        },
        data: {
            type: 'object',
            properties: {
                bags: {
                    type: 'number'
                },
                bitumen: {
                    type: 'number'
                },
                brickTile: {
                    type: 'number'
                },
                concrete: {
                    type: 'number'
                },
                covered: {
                    type: 'number'
                },
                empty: {
                    type: 'number'
                },
                gravel: {
                    type: 'number'
                },
                gypsum: {
                    type: 'number'
                },
                metal: {
                    type: 'number'
                },
                mixedConstructionWaste: {
                    type: 'number'
                },
                mixedMineralicWaste: {
                    type: 'number'
                },
                soil: {
                    type: 'number'
                },
                trackBallast: {
                    type: 'number'
                },
                wood: {
                    type: 'number'
                },
                ewcMapping: {
                    type: 'object',
                    properties: {
                        mixedMineralicWaste: {
                            type: 'string'
                        },
                        bitumen: {
                            type: 'string'
                        },
                        soil: {
                            type: 'string'
                        },
                        gravel: {
                            type: 'string'
                        },
                        concrete: {
                            type: 'string'
                        },
                        brickTile: {
                            type: 'string'
                        },
                        gypsum: {
                            type: 'string'
                        },
                        metal: {
                            type: 'string'
                        },
                        mixedConstructionWaste: {
                            type: 'string'
                        },
                        trackBallast: {
                            type: 'string'
                        },
                        wood: {
                            type: 'string'
                        }
                    }
                }
            }
        },
        key: {
            type: 'string',
            enum: ['truckMaterialClassifier']
        }
    },
    required: ['id', 'evaluatorInstanceVersion', 'report', 'processingStatus', 'version', 'data', 'key']
} as const;

export const TruckRecordingMipReportDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        deletedAt: {
            type: 'string',
            format: 'date-time'
        },
        reporterVersion: {
            '$ref': '#/components/schemas/MipReporterVersionDto'
        },
        observedAt: {
            type: 'string',
            format: 'date-time'
        },
        data: {
            type: 'object'
        },
        processingStatus: {
            '$ref': '#/components/schemas/MipProcessingStatusDto'
        },
        version: {
            type: 'number'
        },
        key: {
            type: 'string',
            enum: ['truckRecording']
        },
        evaluations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TruckRecordingMipEvaluationDTO'
            }
        }
    },
    required: ['id', 'reporterVersion', 'observedAt', 'data', 'processingStatus', 'version', 'key', 'evaluations']
} as const;

export const TruckRecordingMipDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        observedAt: {
            format: 'date-time',
            type: 'string'
        },
        report: {
            '$ref': '#/components/schemas/TruckRecordingMipReportDTO'
        },
        jobsiteId: {
            type: 'string'
        },
        imageId: {
            type: 'string'
        },
        licensePlate: {
            type: 'string'
        },
        deliveryId: {
            type: 'string'
        }
    },
    required: ['id', 'observedAt', 'report', 'jobsiteId']
} as const;

export const TruckRecordingMipFilterDTOSchema = {
    type: 'object',
    properties: {
        observedAt: {
            '$ref': '#/components/schemas/DateFilterDTO'
        }
    }
} as const;

export const TruckRecordingMipQueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const TruckRecordingMipFilterOptionsDTOSchema = {
    type: 'object',
    properties: {
        observedAt: {
            '$ref': '#/components/schemas/FilterDateRangeOptionDTO'
        }
    }
} as const;

export const MipMaterialClassificationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        data: {
            type: 'object',
            properties: {
                bags: {
                    type: 'number'
                },
                bitumen: {
                    type: 'number'
                },
                brickTile: {
                    type: 'number'
                },
                concrete: {
                    type: 'number'
                },
                covered: {
                    type: 'number'
                },
                empty: {
                    type: 'number'
                },
                gravel: {
                    type: 'number'
                },
                gypsum: {
                    type: 'number'
                },
                metal: {
                    type: 'number'
                },
                mixedConstructionWaste: {
                    type: 'number'
                },
                mixedMineralicWaste: {
                    type: 'number'
                },
                soil: {
                    type: 'number'
                },
                trackBallast: {
                    type: 'number'
                },
                wood: {
                    type: 'number'
                },
                ewcMapping: {
                    type: 'object',
                    properties: {
                        mixedMineralicWaste: {
                            type: 'string'
                        },
                        bitumen: {
                            type: 'string'
                        },
                        soil: {
                            type: 'string'
                        },
                        gravel: {
                            type: 'string'
                        },
                        concrete: {
                            type: 'string'
                        },
                        brickTile: {
                            type: 'string'
                        },
                        gypsum: {
                            type: 'string'
                        },
                        metal: {
                            type: 'string'
                        },
                        mixedConstructionWaste: {
                            type: 'string'
                        },
                        trackBallast: {
                            type: 'string'
                        },
                        wood: {
                            type: 'string'
                        }
                    }
                }
            }
        }
    },
    required: ['id', 'data']
} as const;

export const MipEdgeSizesPredictionDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        data: {
            type: 'object',
            properties: {
                objects: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            width: {
                                type: 'number'
                            },
                            height: {
                                type: 'number'
                            },
                            boundingBox: {
                                type: 'object',
                                description: 'values in relative coordinates',
                                properties: {
                                    xMin: {
                                        type: 'number'
                                    },
                                    xMax: {
                                        type: 'number'
                                    },
                                    yMin: {
                                        type: 'number'
                                    },
                                    yMax: {
                                        type: 'number'
                                    }
                                }
                            }
                        }
                    }
                },
                top1Edge: {
                    type: 'number',
                    description: 'largest detected edge'
                }
            }
        }
    },
    required: ['id', 'data']
} as const;

export const MipSoilClassificationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        data: {
            type: 'object',
            description: 'Soil classification prediction results with probabilities for each class value. Flat key-value pairs as produced by the MIP evaluator schema.',
            properties: {
                biomaterials: {
                    type: 'number'
                },
                'brightness.bright': {
                    type: 'number'
                },
                'brightness.dark': {
                    type: 'number'
                },
                cohesive: {
                    type: 'number'
                },
                'color.black': {
                    type: 'number'
                },
                'color.blue': {
                    type: 'number'
                },
                'color.brown': {
                    type: 'number'
                },
                'color.gray': {
                    type: 'number'
                },
                'color.green': {
                    type: 'number'
                },
                'color.mixed': {
                    type: 'number'
                },
                'color.red': {
                    type: 'number'
                },
                'color.white': {
                    type: 'number'
                },
                'color.yellow': {
                    type: 'number'
                },
                'grainSize.finerThanSand': {
                    type: 'number'
                },
                'grainSize.sand': {
                    type: 'number'
                },
                'gravelShare.0pct': {
                    type: 'number'
                },
                'gravelShare.10pct': {
                    type: 'number'
                },
                'gravelShare.20pct': {
                    type: 'number'
                },
                'gravelShare.30pct': {
                    type: 'number'
                },
                'gravelShare.40pct': {
                    type: 'number'
                },
                'gravelShare.50pct': {
                    type: 'number'
                },
                'mixedWasteShare.0pct': {
                    type: 'number'
                },
                'mixedWasteShare.10pct': {
                    type: 'number'
                },
                'mixedWasteShare.20pct': {
                    type: 'number'
                },
                'mixedWasteShare.30pct': {
                    type: 'number'
                },
                'mixedWasteShare.40pct': {
                    type: 'number'
                },
                'mixedWasteShare.50pct': {
                    type: 'number'
                },
                wet: {
                    type: 'number'
                }
            }
        }
    },
    required: ['id', 'data']
} as const;

export const MipVolumeEstimationEvaluationDtoSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        data: {
            type: 'object',
            properties: {
                kind: {
                    type: 'string',
                    enum: ['full', 'empty']
                },
                licensePlate: {
                    type: 'string',
                    description: 'Uppercase and stripped of whitespaces, dashes'
                },
                lineOfSightVolume: {
                    type: 'number',
                    description: 'in m³'
                },
                version: {
                    type: 'string',
                    description: 'Model version (semver) used to perform the evaluation, e.g. 1.0.2'
                }
            }
        }
    },
    required: ['id', 'data']
} as const;

export const MipVolumeEstimationDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            description: 'evaluationId of full volume evaluation'
        },
        fullLineOfSightVolume: {
            '$ref': '#/components/schemas/MipVolumeEstimationEvaluationDto'
        },
        emptyLineOfSightVolumes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MipVolumeEstimationEvaluationDto'
            }
        }
    },
    required: ['id', 'fullLineOfSightVolume', 'emptyLineOfSightVolumes']
} as const;

export const TrainRecordingDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        motion_start_at: {
            format: 'date-time',
            type: 'string'
        },
        jobsite_id: {
            type: 'string'
        },
        image_id: {
            type: 'string'
        },
        wagon_number: {
            type: 'string'
        }
    },
    required: ['id', 'motion_start_at', 'jobsite_id', 'image_id']
} as const;

export const TrainRecordingFilterDTOSchema = {
    type: 'object',
    properties: {
        motion_start_at: {
            '$ref': '#/components/schemas/DateFilterDTO'
        }
    }
} as const;

export const TrainRecordingQueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const TrainRecordingFilterOptionsDTOSchema = {
    type: 'object',
    properties: {
        motion_start_at: {
            '$ref': '#/components/schemas/FilterDateRangeOptionDTO'
        }
    }
} as const;

export const TrainRecordingAuxCapturesSchema = {
    type: 'object',
    properties: {
        auxIndices: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['auxIndices']
} as const;

export const TrainRecordingAuxImagesSchema = {
    type: 'object',
    properties: {
        numImages: {
            type: 'number'
        }
    },
    required: ['numImages']
} as const;

export const DetectionsDictDTOSchema = {
    type: 'object',
    properties: {
        classes: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'string'
                }
            }
        },
        scores: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'number'
                }
            }
        },
        bbox: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'number'
                }
            }
        },
        sources: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'string',
                    enum: ['alpha', 'stable']
                }
            }
        }
    },
    required: ['classes', 'scores', 'bbox']
} as const;

export const HeapRleMaskDTOSchema = {
    type: 'object',
    properties: {
        size: {
            type: 'array',
            items: {
                type: 'integer',
                minimum: 1
            },
            minItems: 2,
            maxItems: 2,
            description: 'Image dimensions as [height, width] in pixels',
            example: [2064, 2464]
        },
        order: {
            type: 'string',
            enum: ['column'],
            description: 'RLE traversal order'
        },
        counts: {
            type: 'array',
            items: {
                type: 'integer',
                minimum: 0
            },
            description: 'Uncompressed alternating background/foreground run lengths'
        }
    },
    required: ['size', 'order', 'counts']
} as const;

export const HeapRecordingDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        jobsite_id: {
            type: 'string'
        },
        recorded_at: {
            format: 'date-time',
            type: 'string'
        },
        license_plate: {
            type: 'string'
        },
        has_detections: {
            type: 'boolean'
        },
        detections_dict: {
            '$ref': '#/components/schemas/DetectionsDictDTO'
        },
        masks: {
            type: 'object',
            additionalProperties: {
                '$ref': '#/components/schemas/HeapRleMaskDTO'
            },
            description: 'Producer segmentation masks, keyed by the producer mask name'
        },
        version: {
            type: 'string'
        },
        extra_fields: {
            type: 'object',
            additionalProperties: true
        },
        archived: {
            type: 'boolean'
        },
        batch_id: {
            type: 'string'
        },
        camera_id: {
            type: 'string'
        }
    },
    required: ['id', 'jobsite_id', 'recorded_at', 'has_detections']
} as const;

export const HeapRecordingFilterDTOSchema = {
    type: 'object',
    properties: {
        recorded_at: {
            '$ref': '#/components/schemas/DateFilterDTO'
        },
        license_plate: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        has_detections: {
            '$ref': '#/components/schemas/BooleanFilterDTO'
        },
        version: {
            '$ref': '#/components/schemas/StringFilterDTO'
        },
        archived: {
            '$ref': '#/components/schemas/BooleanFilterDTO'
        }
    }
} as const;

export const HeapRecordingQueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            items: {
                type: 'array'
            },
            example: '[{"start_at":{"gt":"2024-08-01T08:33:38.186Z"}}]',
            description: 'filters in the top level array will be combined as logical OR',
            type: 'array'
        }
    }
} as const;

export const HeapRecordingFilterOptionsDTOSchema = {
    type: 'object',
    properties: {
        recorded_at: {
            '$ref': '#/components/schemas/FilterDateRangeOptionDTO'
        },
        license_plate: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        has_detections: {
            '$ref': '#/components/schemas/FilterBooleanOptionDTO'
        },
        version: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FilterStringOptionDTO'
            }
        },
        archived: {
            '$ref': '#/components/schemas/FilterBooleanOptionDTO'
        }
    }
} as const;

export const UpdateHeapRecordingDTOSchema = {
    type: 'object',
    properties: {
        archived: {
            type: 'boolean'
        },
        complaint: {
            type: 'string'
        }
    }
} as const;

export const S3ReferenceSchema = {
    type: 'object',
    properties: {
        bucket: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        etag: {
            type: 'string'
        }
    },
    required: ['bucket', 'key']
} as const;

export const BeltS3RefsDTOSchema = {
    type: 'object',
    properties: {
        original: {
            '$ref': '#/components/schemas/S3Reference'
        }
    },
    required: ['original']
} as const;

export const BeltPredictionValueDTOSchema = {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        value: {
            type: 'number'
        }
    },
    required: ['key', 'value']
} as const;

export const BeltPredictionDTOSchema = {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        values: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BeltPredictionValueDTO'
            }
        }
    },
    required: ['key', 'values']
} as const;

export const BeltDTOSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        observedAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        capturerId: {
            type: 'string'
        },
        imgS3Refs: {
            '$ref': '#/components/schemas/BeltS3RefsDTO'
        },
        predictions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BeltPredictionDTO'
            }
        }
    },
    required: ['id', 'observedAt', 'capturerId', 'predictions']
} as const;

export const QueryDTOSchema = {
    type: 'object',
    properties: {
        sortField: {
            type: 'string',
            description: 'field to sort by'
        },
        sortDirection: {
            type: 'string',
            enum: ['asc', 'desc'],
            description: 'sort direction'
        },
        offset: {
            type: 'number',
            default: 0
        },
        limit: {
            type: 'number',
            default: 100
        },
        filter: {
            type: 'array',
            items: {
                type: 'object'
            }
        }
    }
} as const;